module.exports = "/lucky-balls/img/infobox/info_Box_030.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_030.png
// module id = 1095
// module chunks = 0